<template>
  <AppMain>
    <div class="container mt-4">
      <div class="page-title-container">
        <div class="row">
          <div class="col-12 col-md-7">
            <h1 class="mb-0 pb-0 display-4" id="title">Elimdeki İşler</h1>
            <nav class="breadcrumb-container d-inline-block" aria-label="breadcrumb">
              <ul class="breadcrumb pt-0">
                <li class="breadcrumb-item">
                  <router-link to="/">Anasayfa</router-link>
                </li>
                <li class="breadcrumb-item">
                  <router-link to="/isler">İşler</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Elimdeki İşler</li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <div v-if="loading" class="my-4">Yükleniyor...</div>
      <div v-else>
       
        <div class="row">
          <div :class="seciliIs ? 'col-md-8' : 'col-12'">
            <isCard
              :isler="islerCardProp"
              readonly
              :showFilters="true"
              :seciliIs="seciliIs"
              @seciliIs="isSecildi"
              @update:isler="elimdekiIslerCardGuncelle"
            />
          </div>
          <div class="col-md-4" v-if="seciliIs">
            <div class="card h-100 shadow-sm border-0">
              <div class="card-body position-relative p-4">
                <button class="btn-close position-absolute top-0 end-0 m-3" @click="seciliIs = null" aria-label="Kapat"></button>
                <div class="mb-3 pb-2 border-bottom">
                  <h4 class="fw-bold mb-1 d-flex align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="me-2 text-primary"><circle cx="11" cy="11" r="10"/><path d="M11 7v4l3 3"/></svg>
                    {{ seciliIs.ad }}
                  </h4>
                  <div class="text-muted small mb-1">Müşteri</div>
                  <div class="bg-light rounded p-2 mb-2">{{ musteriUnvan(seciliIs) }}</div>
                  <div class="text-muted small mb-2">İş Açıklaması</div>
                  <div class="bg-light rounded p-2 mb-2">{{ seciliIs.aciklama }}</div>
                  <div class="mt-2">
                    <template v-if="!seciliIs.baslamatarih">
                      <button class="btn btn-success w-100 py-2 fw-bold" @click="iseBasladim(seciliIs)">İşe Başladım</button>
                    </template>
                    <template v-else>
                      <span class="badge bg-warning text-dark w-100 py-2 fs-6">Hazırlanıyor</span>
                    </template>
                  </div>
                </div>
                <div class="mb-3 pb-2 border-bottom">
                  <h6 class="fw-semibold mb-3 d-flex align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="me-2 text-info"><rect x="3" y="3" width="15" height="12" rx="2"/></svg>
                    Yüklenen Çalışmalar
                  </h6>
                  <div class="mb-2 d-flex justify-content-end">
                    <button class="btn btn-primary " @click="calismaYukleModal = true">
                      <i class="fa fa-upload me-1"></i>
                      Çalışma Yükle
                    </button>
                  </div>
                  <div class="row g-2" v-viewer>
                    <div class="col-12 col-sm-6" v-for="(file, index) in (seciliIs.calismalar || [])" :key="index">
                      <div class="card h-100 mb-2 border-0 shadow-sm">
                        <img v-if="isImage(file.dosya)"
                             :src="$globalVariable.uploadUrl + file.dosya"
                             @error="$globalVariable.varsayilanGorsel"
                             class="card-img-top sh-22 rounded-top"
                             style="cursor:pointer"
                             :data-original="$globalVariable.uploadUrl + file.dosya">
                        <div class="card-body pb-0">
                          <a v-if="isImage(file.dosya)"
                             href="javascript:void(0)"
                             class="h7 heading d-block text-truncate"
                             :data-original="$globalVariable.uploadUrl + file.dosya">
                             {{ file.ad }}
                          </a>
                          <span v-else class="h7 heading d-block text-truncate">{{ file.ad }}</span>
                        </div>
                        <div class="card-footer border-0 pt-0 bg-white">
                          <div class="d-flex align-items-center gap-2">
                            <a :href="$globalVariable.uploadUrl + file.dosya" target="_blank" class="btn btn-sm btn-outline-primary flex-fill">
                              İndir
                            </a>
                            <button class="btn btn-sm btn-outline-danger flex-fill" @click="calismaSil(file.id)">Sil</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mb-2">
                  <h6 class="fw-semibold mb-3 d-flex align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="me-2 text-secondary"><path d="M12 20h9"/><path d="M12 4h9"/><rect x="3" y="8" width="15" height="8" rx="2"/></svg>
                    Revizeler
                  </h6>
                  <revizeCard :revizeler="revizeler" :duzenle="revizeler_duzenle" :formKaydetSonrasi="revizelerYenile" @update:revizeler="revizelerGuncelle" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isler.length === 0" class="alert alert-info mt-4">Elinizde iş bulunmamaktadır.</div>
      </div>
    </div>
    <!-- Çalışma Yükle Modal -->
    <div class="modal fade show" tabindex="-1" style="display: block; background: rgba(0,0,0,0.3);" v-if="calismaYukleModal">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Çalışma Yükle</h5>
            <button type="button" class="btn-close" @click="calismaYukleModal = false"></button>
          </div>
          <div class="modal-body">
            <input type="file" class="form-control" @change="calismaDosyaSec" multiple />
            <div class="mt-2">
              <div v-for="(file, index) in seciliCalismalar" :key="index" class="d-flex justify-content-between align-items-center">
                <span>{{ file.name }}</span>
                <button type="button" class="btn btn-sm btn-danger" @click="calismaDosyaKaldir(index)">Kaldır</button>
              </div>
            </div>
            <div v-if="isUploadingCalismalar">
              {{ uploadFileNameCalismalar }} Dosyası Yükleniyor
            </div>
            <div class="progress" v-if="isUploadingCalismalar">
              <div class="progress-bar" role="progressbar" :style="{ width: `${uploadProgressCalismalar}%` }">
                {{ uploadProgressCalismalar }}%
              </div>
            </div>
            <div class="d-flex justify-content-around gap-2 mt-4">
              <button class="btn btn-outline-primary" @click="calismaYukleModal = false">İptal</button>
              <button class="btn btn-primary w-100" @click="cokluCalismalarYukle">Kaydet</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AppMain>
</template>

<script>
import axiosCustom from '@/services/axiosCustom';
import { token } from '@/services/useToken';
import isCard from '@/components/isler/isCard.vue';
import AppMain from '@/components/AppMain.vue';
import revizeCard from '@/components/revizeler/revizeCard.vue';
import { getModulePageSize, setModulePageSize } from "@/services/paginationSettings";

export default {
  name: 'ElimdekiIslerView',
  components: { isCard, AppMain, revizeCard },
  data() {
    return {
      isler: [],
      loading: true,
      seciliIs: null,
      musteriler: [],
      kullanicilar: [],
      revizeler: {
        tumu: [],
        secili: null,
        seciliSayfa: 1,
        sayfadaKayit: 10,
        arananKelime: '',
        islem: 'ekle',
        modal: false,
      },
      dosyalar: [],
      calismaYukleModal: false,
      seciliCalismalar: [],
      isUploadingCalismalar: false,
      uploadProgressCalismalar: 0,
      uploadFileNameCalismalar: '',
      islerCardState: {
        seciliSayfa: 1,
        sayfadaKayit: getModulePageSize("elimdekiIsler"),
        filtreCard: 'tumisler',
        buHaftakiIslerIdler: [],
        revizeliIsIdler: [],
        arananKelime: '',
      },
    };
  },
  watch: {
    seciliIs: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.id) {
          this.revizelerGetir(newVal.id);
          // Lightbox images'ı güncelle
          // this.updateLightboxImages(); // Bu fonksiyon artık kullanılmıyor
        } else {
          this.revizeler.tumu = [];
          // this.lightboxImages = []; // Bu state artık kullanılmıyor
        }
      }
    }
  },
  computed: {
    islerCardProp() {
      return {
        tumu: this.isler,
        ...this.islerCardState,
        // Bu ekranda filtre kartı yok, yanlış filtre state'i gelirse liste boş kalmasın.
        filtreCard: 'tumisler',
      };
    }
  },
  async mounted() {
    if (!token.value) {
      this.$router.push({ name: 'Login' });
      return;
    }
    try {
      const response = await axiosCustom.get('isler/elindekiisler');
      this.isler = this.normalizeIslerResponse(response.data);
      // Müşterileri çek
      const musterilerRes = await axiosCustom.get('musteriler');
      this.musteriler = musterilerRes.data;
      // Dummy: musteriler, kullanicilar, revizeler, dosyalar fetch edilebilir
    } catch (error) {
      this.$toast && this.$toast.error('İşler alınamadı');
      this.isler = [];
    } finally {
      this.loading = false;
    }
  },
  methods: {
    isSecildi(is) {
      this.seciliIs = is;
    },
    elimdekiIslerCardGuncelle(veriler) {
      this.islerCardState = {
        ...this.islerCardState,
        seciliSayfa: veriler.seciliSayfa,
        sayfadaKayit: veriler.sayfadaKayit,
        arananKelime: veriler.arananKelime,
      };
      setModulePageSize("elimdekiIsler", veriler.sayfadaKayit);
    },
    musteriUnvan(is) {
      // seciliIs.musteri_ad veya seciliIs.musteri_unvan varsa öncelikli göster
      if (is.musteri_ad) return is.musteri_ad;
      if (is.musteri_unvan) return is.musteri_unvan;
      // musteriler dizisinden bul
      const musteri = this.musteriler.find(m => m.id == is.musteri);
      if (musteri && musteri.unvan) return musteri.unvan;
      return 'Bilinmiyor';
    },
    
    // Lightbox images'ı güncelle
    // updateLightboxImages() { // Bu fonksiyon artık kullanılmıyor
    //   if (this.seciliIs && this.seciliIs.calismalar) {
    //     this.lightboxImages = this.seciliIs.calismalar.map(file => 
    //       this.$globalVariable.uploadUrl + file.dosya
    //     );
    //   } else {
    //     this.lightboxImages = [];
    //   }
    // },
    
    // Lightbox'ı aç - method adını değiştirdim
    // openLightbox(index) { // Bu fonksiyon artık kullanılmıyor
    //   this.updateLightboxImages(); // Her açılışta güncelle
    //   this.lightboxIndex = index;
    //   this.lightboxVisible = true;
    // },

    // closeLightbox() { // Bu fonksiyon artık kullanılmıyor
    //   this.lightboxVisible = false;
    // },
    
    calismaYukle() {
      // Dummy: Çalışma yükle fonksiyonu
      alert('Çalışma yükle fonksiyonu!');
    },
    calismaDosyaSec(event) {
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        this.seciliCalismalar.push(files[i]);
      }
    },
    calismaDosyaKaldir(index) {
      this.seciliCalismalar.splice(index, 1);
    },
    async cokluCalismalarYukle() {
      if (!this.seciliIs) return;
      const CHUNK_SIZE = 1024 * 1024; // 1 MB
      let toplamChunk = 0;
      let yuklenenChunk = 0;
      for (const file of this.seciliCalismalar) {
        toplamChunk += Math.ceil(file.size / CHUNK_SIZE);
      }
      this.isUploadingCalismalar = true;
      for (const file of this.seciliCalismalar) {
        const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
        for (let chunk = 0; chunk < totalChunks; chunk++) {
          const start = chunk * CHUNK_SIZE;
          const end = Math.min(start + CHUNK_SIZE, file.size);
          const chunkData = file.slice(start, end);
          let formData = new FormData();
          formData.append("fileName", file.name);
          this.uploadFileNameCalismalar = file.name;
          formData.append("fileChunk", chunkData);
          formData.append("currentChunk", chunk);
          formData.append("totalChunks", totalChunks);
          try {
            await axiosCustom.post("isler/calismalaryukle/" + this.seciliIs.id, formData);
            yuklenenChunk++;
            this.uploadProgressCalismalar = Math.round((yuklenenChunk / toplamChunk) * 100);
          } catch (error) {
            console.error('Calismalar yükleme hatası: ', error);
            this.$toast && this.$toast.error('Calismalar yükleme hatası');
            this.isUploadingCalismalar = false;
            return;
          }
        }
      }
      this.isUploadingCalismalar = false;
      this.uploadProgressCalismalar = 100;
      this.$toast && this.$toast.success("Calismalar Yüklendi");
      // Yenilemek için tekrar fetch et
      await this.elimdekiIslerYenile();
      this.calismaYukleModal = false;
      this.uploadFileNameCalismalar = '';
      this.seciliCalismalar = [];
    },
    async calismaSil(id) {
      const result = await this.$swal({
        title: "Emin misiniz?",
        text: "Bu işlemi geri alamayacaksınız!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet, sil!",
        cancelButtonText: "İptal",
      });
      if (result.isConfirmed) {
        try {
          await axiosCustom.post("isler/calismalarsil/" + id);
          this.$toast && this.$toast.success("Calisma Silindi");
          await this.elimdekiIslerYenile();
        } catch (error) {
          console.error("Silme hatası: ", error);
          this.$toast && this.$toast.error("Silme hatası");
        }
      }
    },
    async elimdekiIslerYenile() {
      try {
        const response = await axiosCustom.get('isler/elindekiisler');
        this.isler = this.normalizeIslerResponse(response.data);
        // secili iş güncellensin
        if (this.seciliIs) {
          this.seciliIs = this.isler.find(is => is.id === this.seciliIs.id) || null;
          // Lightbox images'ı da güncelle
          // this.updateLightboxImages(); // Bu fonksiyon artık kullanılmıyor
        }
      } catch (error) {
        this.$toast && this.$toast.error('İşler alınamadı');
        this.isler = [];
      }
    },
    normalizeIslerResponse(data) {
      if (Array.isArray(data)) {
        return data;
      }

      if (Array.isArray(data?.data)) {
        return data.data;
      }

      if (Array.isArray(data?.isler)) {
        return data.isler;
      }

      return [];
    },
    async revizelerGetir(isId) {
      try {
        const response = await axiosCustom.get(`isler/detay/${isId}`);
        this.revizeler.tumu = response.data.revizeler || [];
      } catch (error) {
        this.revizeler.tumu = [];
      }
    },
    revizelerGuncelle(veriler) {
      this.revizeler = veriler;
    },
    revizelerYenile() {
      if (this.seciliIs && this.seciliIs.id) {
        this.revizelerGetir(this.seciliIs.id);
      }
    },
    revizeler_duzenle(veri) {
      this.revizeler.secili = veri;
      this.revizeler.islem = 'duzenle';
      this.revizeler.modal = true;
    },
    async iseBasladim(is) {
      const result = await this.$swal({
        title: `${is.ad} işine başladınız mı?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Evet',
        cancelButtonText: 'Hayır',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
      });
      if (result.isConfirmed) {
        try {
          await axiosCustom.post(`isler/isebasla/${is.id}`);
          this.$toast && this.$toast.success('İşe başlama tarihi kaydedildi');
          await this.elimdekiIslerYenile();
          // seciliIs güncelle
          this.seciliIs = this.isler.find(item => item.id === is.id) || null;
        } catch (e) {
          this.$toast && this.$toast.error('Başlatılamadı');
        }
      }
    },
    isImage(filename) {
      const ext = filename.split('.').pop().toLowerCase();
      return ["jpg","jpeg","png","gif","webp","bmp","svg"].includes(ext);
    }
  },
};
</script>

<style scoped>
</style>